<template>
	<div>
		<el-dialog v-model="dialogTableVisible" :show-close="false" title="查看图片" top="4vh" :width="dialogWidth"
			:close-on-click-modal='false' :close-on-press-escape='false'>
			<template #header>
				<el-row>
					<el-col :span="22" v-if="select_info">
						<el-row>
							<el-col :span="6">
								<el-col :span="24">
									<div class="goodDetails_name_title" style="">
										<span class="content">
											型号：{{ img_title.model }}
										</span>
									</div>
								</el-col>
								<el-col :span="24">
									<div class="goodDetails_name_title" style="">
										<span class="content">
											订货号：{{ img_title.order_no }}
										</span>
									</div>
								</el-col>
							</el-col>
							<el-col :span="18" style="margin-top:20px">
								<div class="goodDetails_name_title" style="">
									<span class="content">
										数量：{{ img_title.sur_num }}
									</span>
									<span class="content">
									</span>
									<span class="content" v-if="select_info" style="float: right;">
										<el-button type="danger" style="color:#fff;margin-right: 0.75rem;"
											@click="del">删除</el-button>
										<el-select style="width: 10rem" v-model="img_title.stock_type_txt">
											<el-option v-for="item in stocktype_list" :key="item.name"
												:label="item.name" :value="item.name" />
										</el-select>
										<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;"
											@click="updateStorckType">保存</el-button>
										<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;"
											@click="$emit('cutImg', this.img_title.index + 1, 1)">下一个产品</el-button>
									</span>
								</div>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="22" v-else>
						<div class="goodDetails_name_title" style="">
							<span class="top">
								查看图片
							</span>
							<span class="content">
								型号：{{ img_title.model }}
							</span>
							<span class="content">
								订货号：{{ img_title.order_no }}
							</span>
							<span class="content">
								数量：{{ img_title.sur_num }}
							</span>
						</div>
					</el-col>
					<el-col :span="2" style="text-align:right" class="Share_Close">
						<el-icon size="18px" @click="showShare_click" v-if="share_info">
							<Share />
						</el-icon>
						<el-icon size="18px" style="margin-left:10px" @click="dialogTableVisible = false">
							<Close />
						</el-icon>
					</el-col>
				</el-row>
			</template>
			<el-tabs v-model="activeName" class="demo-tabs" @tab-change="handleClick">
				<el-tab-pane label="当前详情" name="img">
					<div class="goodDetails_name_img">
						<div class="goodDetails_name_img_div" style="height:62vh">
							<el-image :src="imgBigUrl" style="width: 100%;height: 100%" :preview-src-list="data"
								:zoom-rate="1.2" :initial-index="idx">
								<template #error>
									<div style="padding: 25% 45%;">
										暂无图片
									</div>
								</template>
							</el-image>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="疑似关联" name="list">
					<template #label>
						<span>
							<el-badge v-if="img_title.associate && img_title.associate.length" :max="10000000"
								:value="img_title.associate.length" class="item">
								<span>疑似关联</span>
							</el-badge>
							<span v-else>疑似关联</span>
						</span>
					</template>
					<div class="goodDetails_name_img">
						<div class="goodDetails_name_img_div" style="height:62vh;overflow: auto;">
							<div class="associate-table">
								<!-- 表头 -->
								<div class="associate-table-header">
									<div class="th col-type"></div>
									<div class="th col-status">货物状态</div>
									<div class="th col-brand">品牌</div>
									<div class="th col-model">型号</div>
									<div class="th col-orderno">订货号</div>
									<div class="th col-num">数量</div>
									<div class="th col-price">脱手单价</div>
									<div class="th col-estimate">市场估价</div>
								</div>
								<!-- 主商品固定数据 -->
								<div class="associate-table-row main-row">
									<div class="td col-type"><span class="tag-main">脱手商品</span></div>
									<div class="td col-status">
										<div class="stock_type_txt_button">
											<span
												v-for="(item, idx) in (img_title.stock_type_txt ? img_title.stock_type_txt.split('、') : [])"
												:key="idx">
												<el-button class="A" size="small" text bg
													v-if="item == '二手' || item == '过保' || item == '包附破损'">{{ item
													}}</el-button>
												<el-button class="C" size="small" text bg v-else color="#ff8a5c">{{ item
													}}</el-button>
											</span>
										</div>
									</div>
									<div class="td col-brand">{{ img_title.brand_name || '-' }}</div>
									<div class="td col-model">{{ img_title.model || '-' }}</div>
									<div class="td col-orderno">{{ img_title.order_no || '-' }}</div>
									<div class="td col-num">{{ img_title.sur_num || '-' }}</div>
									<div class="td col-price price-value">{{img_title.tsw_price
										|| '-'}}
									</div>
									<div class="td col-estimate price-value">{{  '-' }}</div>
								</div>
								<!-- 疑似关联卡片模式 -->
								<div class="associate-cards">
									<div class="associate-card" v-for="(item, index) in img_title.associate">
										<div class="associate-card-row">
											<div class="td col-type"><span class="tag-associate">疑似关联</span></div>
											<div class="td col-status"><span class="stock-tag">全新</span></div>
											<div class="td col-brand">{{ item.brand_name || '-' }}</div>
											<div class="td col-model">{{ item.model || '-' }}</div>
											<div class="td col-orderno">{{ item.order_no || '-' }}</div>
											<div class="td col-num">{{ item.num || item.sur_num || '-' }}</div>
											<div class="td col-price price-value">{{ '-' }}</div>
											<div class="td col-estimate price-value">{{  item.real_price || '-' }}</div>
										</div>
										<div class="associate-card-remark" v-if="item.remark">
											<span class="remark-label">备注：</span>
											<span class="remark-content"
												v-html="item.remark.replace(/\n/g, '<br>')"></span>
										</div>
									</div>
								</div>
					</div>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
			<div class="goodDetails_name_img">
				<el-row>
					<el-col :xs="7" :sm="5" :md="5" :lg="3" :xl="3" v-if="cutImg_info" style="margin-top: 2.5rem;">
						<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;"
							@click="$emit('cutImg', this.img_title.index - 1, 1)">上一个产品</el-button>
					</el-col>
					<el-col :xs="cutImg_info ? 10 : 24" :sm="cutImg_info ? 14 : 24" :md="cutImg_info ? 14 : 24"
						:lg="cutImg_info ? 18 : 24" :xl="cutImg_info ? 18 : 24">
						<div class="little_img">
							<span v-for="(item, index) in data" :key="index" @mouseenter="getUrl(item, index)">
								<img :src="item">
							</span>
						</div>
					</el-col>
					<el-col :xs="7" :sm="5" :md="5" :lg="3" :xl="3" v-if="cutImg_info && !select_info"
						style="margin-top: 2.5rem;">
						<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;"
							@click="$emit('cutImg', this.img_title.index + 1, 1)">下一个产品</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
		<el-dialog title="分享" v-model="showShare" width="40%" :close-on-click-modal='false'
			:close-on-press-escape='false'>
			<el-form :model="shareForm">
				<el-form-item label="分享标题">
					<el-input placeholder="请输入分享标题" class="shareInp" v-model="shareForm.title"></el-input>
				</el-form-item>
				<!-- <el-form-item label="一口总价">
          <el-input placeholder="请输入一口总价" class="shareInp" v-model="shareForm.price"></el-input>
        </el-form-item> -->
				<el-form-item label="货主备注">
					<el-input placeholder="请输入您的联系方式，地址等" class="shareInp" type="textarea" :rows="3"
						v-model="shareForm.remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" style="text-align:right">
				<el-button @click="cancleShare" class="cancle_btn">取 消</el-button>
				<el-button class="set_btn" @click="sureShare">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="分享" :close-on-click-modal="false" v-model="showqr" width="250">
			<div id="qrcode" style="text-align:center">
				<qrcode-vue :value="QRCodeVue_text" v-if="QRCodeVue_text" :size="200" level="H" />
			</div>
			<div class="qrText" style="text-align:center">分享至微信朋友圈</div>
		</el-dialog>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
export default {
	name: '',
	components: {

	},
	data() {

		return {
			activeName: 'img',
			select_info: false,
			stocktype_list: [{
				id: 'A',
				name: '滞纳、在保、包附完好'
			},
			{
				id: 'B',
				name: '滞纳、在保、包附破损'
			},
			{
				id: 'C',
				name: '滞纳、过保、包附完好'
			},
			{
				id: 'D',
				name: '滞纳、过保、包附破损'
			},
			{
				id: 'E',
				name: '二手、在保、包附完好'
			},
			{
				id: 'F',
				name: '二手、在保、包附破损'
			},
			{
				id: 'G',
				name: '二手、过保、包附完好'
			},
			{
				id: 'H',
				name: '二手、过保、包附破损'
			}
			],
			QRCodeVue_text: '',
			shareForm: {},
			imgBigUrl: '',
			idx: 0,
			showqr: false,
			dialogTableVisible: false,
			showShare: false,
			share_info: true,
			cutImg_info: false,
			data: [],
			img_title: { model: '', order_no: '', sur_num: '', name: '', associate: [] },
			windowWidth: window.innerWidth, // 屏幕宽度（用于响应式弹窗宽度）
		}
	},
	props: [],

	computed: {
		/**
		 * 根据屏幕宽度计算弹窗百分比宽度
		 * @returns {string} 弹窗宽度百分比
		 */
		dialogWidth() {
			if (this.windowWidth >= 1820) {
				return '60%';
			} else if (this.windowWidth >= 1440) {
				return '70%';
			} else if (this.windowWidth >= 1280) {
				return '80%';
			} else {
				return '90%';
			}
		}
	},

	updated() {

	},

	watch: {

	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.handleResize);
		});
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},

	activated() {

	},
	created() {

	},

	methods: {
		/**
		 * 窗口 resize 事件处理，更新 windowWidth
		 */
		handleResize() {
			this.windowWidth = window.innerWidth;
		},

		handleClick() {

		},
		del() {
			ElMessageBox.confirm(
				'确认删除此数据，不可恢复！',
				'提示', {
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning',
			}
			)
				.then(() => {

					this.del_ajax()
				})
				.catch(() => {

				})

		},
		async del_ajax() {
			this.loading = true
			await this.$axios.post('/api/yunsys.storage/deletestorage', { ids: [this.img_title.id] }).then(async (res) => {
				var res = res.data;
				this.loading = false
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
				this.$emit('cutImg', this.img_title.index, 1, true)
				return ElMessage({
					message: res.msg,
					type: 'success',
					grouping: true // 开启合并功能
				})

			})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		async updateStorckType() {
			await this.$axios.post('/api/yunsys.storage/updateoneinfo', { stock_type_txt: this.img_title.stock_type_txt, id: this.img_title.id }).then(async (res) => {
				var res = res.data;
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
				//需要修改外面列表的货物状态
				this.$emit('stockTypeTxtSave', this.img_title);
				return ElMessage({
					message: res.msg,
					type: 'success',
					grouping: true // 开启合并功能
				})


			})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})

		},
		getUrl(url, idx) {
			this.imgBigUrl = url
			this.idx = idx

		},
		cancleShare() {
			this.showShare = false
			this.shareForm = {}
		},
		async showShare_click() {
			await this.$axios.post('/api/yunsys.Website/getnameandtel', this.shareForm).then(async (res) => {
				var res = res.data;
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
				this.shareForm.title = this.img_title.brand_name + ' ' + this.img_title.name + ' ' + this.img_title.model + ' 数量:' + this.img_title.num;
				this.shareForm.remark = res.data.linkman + res.data.mobile;
				this.showShare = true

			})
				.catch(err => {
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		// 确认分享
		async sureShare() {
			if (!this.shareForm.title) {
				return ElMessage({
					message: '请填写分享标题',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			this.shareForm.id = [this.img_title.id]
			await this.$axios.post('/api/yunsys.storage/share', this.shareForm).then(async (res) => {
				var res = res.data;
				this.loading = false
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
				this.QRCodeVue_text = res.data.url

				this.$nextTick(function () {
					this.showqr = true
					this.showShare = false
					this.shareForm = {}

				})
				/*return ElMessage({
					message: res.msg,
					type: 'success',
					grouping: true // 开启合并功能
				})*/

			})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})


		},
	}
}
</script>
<style lang="less" scoped>
:deep(.content .el-select) {
	width: 220px;
}

:deep(.el-button > span) {
	margin-right: 0px;
}

.goodDetails_name_title {
	line-height: 34px;
	overflow: hidden;
	white-space: nowrap;
}

.Share_Close {
	line-height: 34px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

:deep(.el-tabs__item.is-active) {
	// background-color: #f56c6c; /* 选中标签的背景颜色 */
	//border-color: #f56c6c; /* 选中标签的边框颜色 */
	color: #ff8a5c;
	/* 选中标签的文字颜色 */
}

:deep(.el-tabs__active-bar) {
	background-color: #ff8a5c;
	/* 选中标签下方的横线颜色 */
}

:deep(.el-input-group__append) {
	background: #ff8a5c;
}

:deep(.el-image-viewer__canvas .el-image-viewer__img) {
	height: auto !important;
	width: auto !important;
}

:deep(.my-label) {
	background: #ff8a5c !important;
}

:deep(.my-content) {
	background: #ff8a5c !important;
}

:deep(.remark_descriptions) {
	height: 80px;
}

/* 疑似关联表格样式 */
.associate-table {
	border-radius: 6px;
	overflow: hidden;
	font-size: 13px;
}

.associate-table-header {
	display: flex;
	background: #f5f7fa;
	color: #606266;
	font-weight: 600;
}

.associate-table-header .th {
	padding:4px 3px;
	text-align: center;
	border-right: 1px solid #ebeef5;
	line-height: 1.4;
}

.associate-table-header .th:last-child {
	border-right: none;
}

.associate-table-row {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #ebeef5;
	transition: background 0.2s;
}

.associate-table-row:last-child {
	border-bottom: none;
}

.associate-table-row:hover {
	background: #fff8f3;
}

.associate-table-row.main-row {
	background: #f5f7fa;
	font-weight: 500;
}

.associate-table-row.main-row:hover {
	background: #ebeef5;
}

.associate-table-row .td {
	padding: 4px 4px;
	text-align: center;
	border-right: 1px solid #ebeef5;
	color: #303133;
	word-break: break-all;
}

.associate-table-row .td:last-child {
	border-right: none;
}

.col-type {
	width: 8%;
	min-width: 60px;
}

.col-status {
	width: 17%;
	min-width: 130px;
}

.col-brand {
	width: 15%;
	min-width: 120px;
}

.col-model {
	width: 18%;
	min-width: 140px;
}

.col-orderno {
	width: 18%;
	min-width: 140px;
}

.col-num {
	width: 6%;
	min-width: 50px;
}

.col-price {
	width: 7%;
	min-width: 60px;
}

.col-estimate {
	width: 6%;
	min-width: 50px;
}

.tag-main {
	display: inline-block;
	padding: 2px 8px;
	border-radius: 10px;
	font-size: 12px;
	font-weight: 600;
}

.tag-associate {
	display: inline-block;
	padding: 2px 8px;
	border-radius: 10px;
	font-size: 12px;
	font-weight: 600;
}

.price-value {
	color: #f56c6c;
	font-weight: 600;
}

.stock_type_txt_button {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 3px;
}

:deep(.associate-table .stock_type_txt_button .el-button > span) {
	margin-right: 0;
}

.associate-remark-row {
	margin-top: 10px;
	padding: 10px 14px;
	background: #fafafa;
	border-left: 3px solid #ff8a5c;
	border-radius: 0 4px 4px 0;
	line-height: 1.7;
	font-size: 13px;
}

.associate-remark-row+.associate-remark-row {
	margin-top: 6px;
}

.remark-label {
	//color: #ff8a5c;
	font-weight: 600;
	margin-right: 6px;
}

.remark-content {
	color: #606266;
}

/* 关联卡片模式样式 */
.associate-cards {
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-top: 10px;
}

.associate-card {
	background: #fff;
	border: 1px solid #ebeef5;
	border-radius: 8px;
	padding: 0;
	overflow: hidden;
	transition: box-shadow 0.2s, border-color 0.2s;
}

.associate-card:hover {
	box-shadow: 0 2px 12px rgba(255, 138, 92, 0.15);
	border-color: #ff8a5c;
}

.associate-card-row {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #ebeef5;
	padding:6px 0;
}

.associate-card-row .td {
	padding: 0px 3px;
	text-align: center;
	border-right: 1px solid #ebeef5;
	color: #303133;
	white-space: nowrap;
	word-break: break-all;
}

.associate-card-row .td:last-child {
	border-right: none;
}

.stock-tag {
	display: inline-block;
	padding: 2px 8px;
	background: #f0f9eb;
	color: #67c23a;
	border-radius: 10px;
	font-size: 12px;
	font-weight: 500;
}

.associate-card-remark {
	text-align: left;
	padding: 18px 16px;
	border-top: 1px dashed #ebeef5;
	font-size: 13px;
	line-height: 1.6;
}

.associate-card-remark .remark-label {
	font-weight: 600;
	margin-right: 4px;
}

.associate-card-remark .remark-content {
	color: #606266;
}
</style>